import {
  GET_DOMAINS,
  GET_DOMAINS_SUCCESS,
  GET_DOMAINS_FAIL,

  GET_DOMAIN_RECORDS,
  GET_DOMAIN_RECORDS_SUCCESS,
  GET_DOMAIN_RECORDS_FAIL,

  EDIT_RECORD,
  EDIT_RECORD_SUCCESS,
  EDIT_RECORD_FAIL,

  ADD_RECORD,
  ADD_RECORD_SUCCESS,
  ADD_RECORD_FAIL,

  DNS_RECORDS_SEARCH
} from '../constants/dns'

const initialState = {
  domains: null,
  records: null,
  loadingDomains: false,
  loadingRecords: false,
  editingRecord: false,
  error: null,
  dnsSearchResult: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DOMAINS:
      return {
        ...state,
        loadingDomains: true,
        error: null
      }
    case GET_DOMAINS_SUCCESS:
      return {
        ...state,
        loadingDomains: false,
        error: null,
        domains: action.data
      }
    case GET_DOMAINS_FAIL:
      return {
        ...state,
        loadingDomains: false,
        error: action.error
      }
    case GET_DOMAIN_RECORDS:
      return {
        ...state,
        loadingRecords: true,
        error: null
      }
    case GET_DOMAIN_RECORDS_SUCCESS:
      return {
        ...state,
        loadingRecords: false,
        records: action.data,
        error: null
      }
    case GET_DOMAIN_RECORDS_FAIL:
      return {
        ...state,
        loadingRecords: false,
        error: action.error
      }
    case EDIT_RECORD_SUCCESS:
      return {
        ...state,
        records: state.records.map((record, idx) => action.data.idx === idx ? { data: action.data.ip, name: action.data.subdomain, type: action.data.type } : record),
        error: null
      }
    case ADD_RECORD_SUCCESS:
      return {
        ...state,
        records: [{ data: action.data.ip, name: action.data.subdomain, type: action.data.type }, ...state.records],
        error: null
      }
    case ADD_RECORD_FAIL:
    case EDIT_RECORD_FAIL:
      return {
        ...state,
        error: action.error
      }
    case DNS_RECORDS_SEARCH:
      return {
        ...state,
        dnsSearchResult: action.dnsSearchResult
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/dns.js